import * as React from 'react';

function NoClosureWarningIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} width="61" height="61" viewBox="0 0 61 61" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.5003 7.62435C17.8668 7.62435 7.62533 17.8658 7.62533 30.4993C7.62533 43.1329 17.8668 53.3743 30.5003 53.3743C43.1338 53.3743 53.3753 43.1329 53.3753 30.4993C53.3753 17.8658 43.1338 7.62435 30.5003 7.62435ZM2.54199 30.4993C2.54199 15.0584 15.0594 2.54102 30.5003 2.54102C45.9413 2.54102 58.4587 15.0584 58.4587 30.4993C58.4587 45.9403 45.9413 58.4577 30.5003 58.4577C15.0594 58.4577 2.54199 45.9403 2.54199 30.4993Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.4821 21.0775C45.4752 22.0696 45.476 23.6789 44.4839 24.672L29.2329 39.9472C28.7563 40.4242 28.1097 40.6923 27.4354 40.6925C26.7611 40.6926 26.1143 40.4249 25.6375 39.9481L18.0125 32.3231C17.0199 31.3305 17.0199 29.7212 18.0125 28.7286C19.0051 27.736 20.6144 27.736 21.607 28.7286L27.4338 34.5555L40.8876 21.0793C41.8797 20.0862 43.489 20.0854 44.4821 21.0775Z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoNoClosureWarningIcon = React.memo(NoClosureWarningIcon);
export default MemoNoClosureWarningIcon;
